<ngx-loading [show]="loading" [config]="{fullScreenBackdrop : true}"></ngx-loading>  
<div class="container">
  <div class="card" style="border: 1px solid; color: #9b7544">
  <div class="row" *ngIf="pet">
    <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6 " style="margin-top:1%">
        <div class="row" style="margin-left: 2%" >
          <div class="col text-center">
              <img  style=" width:100% ; max-height:200px" src="https://passport.petcart.in/images/petimages/{{pet.image}}" class="rounded" >
          </div>
            
        </div>
        <div class="row " *ngIf="div1">
          <div class="col text-center">
              <input type="file" style="text-align:center" ngFileSelect [options]='options' (onUpload)="handleUpload($event)" (beforeUpload)="beforeUpload($event)">
          </div>
          
        </div>
           
    </div>
    <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6 " style="margin-top:1%">
       <div class="row">
         <div class="col text-center">
            <h4 class="quickFade delayTwo"  style="font-size:25px; font-style: open sans ">Name: {{pet.pet_name}}</h4>
         </div>
         </div>
       <div class="row" text-center>
         <div class="col text-center">
            <h4  style="font-size:25px; font-style: open sans ">Bio: {{pet.bio}}</h4>
         </div>
         
       </div>
       <div class="row" text-center>
          <div class="col text-center">
             <h4  style="font-size:25px; font-style: open sans " *ngIf="pet.dob && pet.dob !='0000-00-00'">Date of Birth: {{pet.dob}}</h4>
          </div>
          
        </div>
  </div>
  
</div>
</div>
<mat-tab-group style="margin-top:3%">
    <mat-tab label="Appointment" style="font-size:25px">
        <div *ngIf="appointment && appointment.length>0;  else NoAppointmentFound">
            <div class="row">
                      <div class="col-sm-6 col-md-6 col-lg-4 col-xl-4" *ngFor="let data of appointment">
                  <div class="card" style="margin-top: 5%">
                      <div class="card-header">
                       <div class="row">
                         <div class="col">
                          <img class="avatar" src = "https://passport.petcart.in/images/userimgs/{{photo['id'+data.serviceprovider_id]}}">
                         </div>
                         <div class="col">
                            <h4 style="font-style: open sans"> {{doctorname['id'+data.serviceprovider_id]}}</h4> 
                          </div>
                       </div>
                      </div>
                      <div class="card-body">
                          <div class="row">
                              <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                  <p  style="font-style: open-sans;" >Date : {{data.date}}</p>
                                </div>
                                <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                    <p  style="font-style: open-sans;" >start Time : {{data.start_time | slice : 0:5}} </p>
                                  </div> 
                                  <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                      <p  style="font-style: open-sans;" >End Time: {{data.end_time | slice : 0:5}}</p>
                                    </div> 
                                    <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                        <p  style="font-style: open-sans;" >Status: {{data.status}}</p>
                                      </div> 
                                 </div>
                      </div>
                     <div class="card-footer">
                       <div class="row">
                         <div class="col-12">
                            <button class="btn btn-success3 btn-block" routerLink='/manageprofile/appointmentdetail/{{data.id}}'>Detail</button> 
                         </div>
                       </div>
                     </div>
                        
                      </div>
                  </div>
              </div>
         </div>
         <div class="row" style="margin-top:2% ; margin-bottom:2%">
           <div class="col-6">
              <button  class="btn btn-success2 btn-block"  routerLink="/pulse/home">Take Appointment</button>  
           </div>
           <div class="col-6">
              <button  class="btn btn-secondary btn-block"  routerLink="/manageprofile/manageyourpet">Go Back</button>  
           </div>
         </div>     
      
          
   </mat-tab>
    <mat-tab style="font-size:25px" label="Documents" >
      <div class="row" style="margin-top: 1% ; margin-bottom: 1%" *ngIf="div1 === true">
        <div class="col-12">
          <button class="btn btn-secondary btn-block" (click)=" openUploadForm()">
            Upload New Document
          </button>
        </div>
      </div>
      <div class="row" *ngIf="div1 === true && petdocs">
        <div class="col-12" *ngFor=" let docs of petdocs | paginate: { itemsPerPage: 4, currentPage: p } ">
            <div class="card"style="margin-top:3%" >
              <div class="card-body">
                 <div class="row">
                   <div class="col-sm-4 col-md-2 col-lg-2 col-xl-2 text-center" *ngIf= "getFileExtension(docs.path) === 'png' 
                   || getFileExtension(docs.path) === 'jpg'  || getFileExtension(docs.path) === 'bmp' ||
                    getFileExtension(docs.path) === 'gif'; else textimage">
                      <img class="avatar1 "  src="https://passport.petcart.in/images/petimages/{{docs.path}}">
                   </div>
                   <div class="col-sm-4 col-md-3 col-lg-3 col-xl-3 text-center" style="margin-top:20px">
                    <p><strong>Type: {{docs.document_type}}</strong></p>  
                    </div>
                    <div class="col-sm-4 col-md-3 col-lg-3 col-xl-3 text-center" style="margin-top:20px">
                        <p><strong>sublect : {{docs.subject}}</strong></p>  
                        </div>
                        <div class="col-sm-4 col-md-3 col-lg-3 col-xl-3 text-center" style="margin-top:20px">
                            <p><strong>Date : {{docs.created_at | slice: 0 : 10}}</strong></p>  
                            </div>
                            <div class="col-sm-4 col-md-1 col-lg-1 col-xl-1 text-center" style="margin-top:20px">
                                <a href="https://passport.petcart.in/images/petimages/{{docs.path}}" download>
                                 <mat-icon>file_download</mat-icon>
                                </a>
                            </div>
                 </div>
              </div>
              </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <pagination-controls  (pageChange)="p = $event"></pagination-controls >
                </div>
            </div>
        </div>     
        <div class="card" *ngIf="div2 === true ">
                <div class="row">
                <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4 col-center">
                        <label>Select Document Type</label>
                          <select name='dt' [(ngModel)]="dtype">
                            <option value="prescription">Prescription</option>
                           <option value="testreport">test Report</option>
                          </select>
                      </div>
                      <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4 col-center">
                            <input type="text" style="text-align:center" placeholder="subject of docs"  [(ngModel)]="dsub">
                            </div>
                 <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4 col-center"  *ngIf="dtype && dsub">
                        <input type="file" style="text-align:center" ngFileSelect [options]='options1' (onUpload)=" handleUploaddoc($event)" (beforeUpload)="beforeUpload2($event)">
                 </div>
            </div>
            <div class="row" style="margin: 2%">
                    <div class="col-12" >
                            <div class="progress" *ngIf="upflag == 1" >
                                    <div class="progress-bar progress-bar-striped active" role="progressbar"
                                    aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width:100%">
                                      40%
                                    </div>
                                  </div>
                            <label *ngIf="upflag == 2" style="font-style: open sans; font-size:25px; color:green">Successfuly upload</label>
                      </div>
                      </div>
        <div class="card-footer" style="margin-top:2%">
              <div class="row">
              <div class="col-12">
                  <button class="btn btn-success btn-block"  *ngIf="upflag == 0 " (click)="openUploadForm()">Cancel</button>
                  <button class="btn btn-info btn-block"  *ngIf="upflag == 2" (click)="openUploadForm()">Ok</button>
                </div>
            </div>
        </div>
      </div>
     </mat-tab>
  </mat-tab-group>

</div>
 
<ng-template #NoAppointmentFound style="font-color:red; margin-top: 50%">
    <div class="container">
        <mat-card style="margin-top: 5%">
          <div class="row">
            <div class="col-sm-6" text-center >
                <label style="color: #cb983f;font-size: 18px "> 
                    No Appointment Found  </label>   
            </div>
            <div class="col-sm-6" text-center >
                <button  class="btn btn-success2 btn-block"  routerLink="/pulse/home">Take Appointment</button> 
            </div>
          </div>
           
            </mat-card>
    </div>
</ng-template>

<ng-template #textimage>
    <div class="col-sm-4 col-md-2 col-lg-2 col-xl-2 text-center">
        <img class="avatar1 " src="https://passport.petcart.in/images/petimages/doc.png">
    </div>
    
</ng-template>